import PropTypes from 'prop-types';
import React from 'react';
import Select from "react-select";

const SelectMenu = (props) => {
    const { optionList, handleChange, value, placeholderText, name, closeOnSelect, classPrefix, isMulti = false, isEditable } = props;
    return (
        <Select
            {...props}
            options={optionList}
            onChange={(value) => handleChange(value, name)}
            value={value}
            placeholder={placeholderText}
            classNamePrefix={classPrefix || 'list'}
            className='Select-control'
            isMulti={isMulti}
            closeMenuOnSelect={closeOnSelect}
            isDisabled={isEditable}
        />
    );
}

SelectMenu.propTypes = {
    optionList: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string,
        PropTypes.number
    ]),
    name: PropTypes.string.isRequired,
    placeholderText: PropTypes.string,
    closeOnSelect: PropTypes.bool,
    classPrefix: PropTypes.string,
    isMulti: PropTypes.bool,
    isEditable: PropTypes.bool
}

export default SelectMenu;